// page-pedidos-wrapper.component.ts

import { Component, OnInit } from "@angular/core";
import { Configuracoes } from "src/app/core/entities/configuracoes";

@Component({
  selector: "app-page-meus-dados-wrapper",
  template: `
    <!-- <app-page-meus-dados *ngIf="!isB2c"></app-page-meus-dados> -->
    <app-page-meus-dados-b2c></app-page-meus-dados-b2c>
  `,
})
export class PageMeusDadosWrapperComponent implements OnInit {
  isB2c = false;

  constructor() {
    this.isB2c = Configuracoes.layoutB2c
  }

  ngOnInit() {
    this.isB2c = Configuracoes.layoutB2c
  }
}